import { render, staticRenderFns } from "./TypeAndAdminMiniPopup.vue?vue&type=template&id=57c4b5c9&"
import script from "./TypeAndAdminMiniPopup.vue?vue&type=script&lang=ts&"
export * from "./TypeAndAdminMiniPopup.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports